var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnderTraining(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 156,
    viewBox: "0 0 310 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.855 26.6129H123.491V67.4475H190.855V26.6129Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.491 41.3738C119.469 42.7111 117.293 47.0554 118.63 51.077C119.394 53.3726 121.195 55.1737 123.491 55.9371",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.173 26.6129V21.9169L149.561 19.372L156.275 12.6628L153.326 9.71061V7.76062",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.517 26.6129V20.229L153.899 18.3508L159.59 12.6642L155.67 8.7402V7.57275",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M157.681 4.44206C157.681 2.54111 156.14 1 154.239 1C152.338 1 150.797 2.54104 150.797 4.44206C150.797 6.34308 152.338 7.88412 154.239 7.88412C156.14 7.88412 157.681 6.34308 157.681 4.44206Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.789 44.6353C145.789 40.7502 142.64 37.6006 138.754 37.6006C134.869 37.6006 131.72 40.7501 131.72 44.6353C131.72 48.5205 134.869 51.67 138.754 51.67C142.64 51.67 145.789 48.5204 145.789 44.6353Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M144.236 44.7024C144.236 42.4765 142.432 40.672 140.206 40.672C137.98 40.672 136.175 42.4765 136.175 44.7024C136.175 46.9284 137.98 48.7329 140.206 48.7329C142.432 48.7329 144.236 46.9284 144.236 44.7024Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M182.626 44.6353C182.626 40.7502 179.477 37.6006 175.591 37.6006C171.706 37.6006 168.557 40.7501 168.557 44.6353C168.557 48.5205 171.706 51.67 175.591 51.67C179.477 51.67 182.626 48.5204 182.626 44.6353Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M180.484 44.355C180.484 42.129 178.68 40.3245 176.454 40.3245C174.228 40.3245 172.423 42.1289 172.423 44.355C172.423 46.581 174.228 48.3854 176.454 48.3854C178.68 48.3854 180.484 46.5809 180.484 44.355Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M190.855 55.937C194.877 54.5996 197.053 50.2553 195.715 46.2337C194.952 43.9382 193.151 42.137 190.855 41.3737",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M189.697 76.3101H126.836V139.122H189.697V76.3101Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M163.405 76.3099V67.4475",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M153.128 76.3099V67.4475",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M153.128 71.8787C154.585 72.0867 156.041 72.2948 157.501 72.3338C159.466 72.3864 161.435 72.1325 163.405 71.8787",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M126.836 76.3101C120.933 79.0025 118.331 85.9705 121.023 91.8734C122.197 94.4481 124.262 96.5124 126.836 97.6866",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1 154.666H309.085",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M137.892 82.9961H178.445C178.676 82.9961 178.862 83.1828 178.862 83.4132V117.593C178.862 117.824 178.676 118.01 178.445 118.01H137.892C137.662 118.01 137.475 117.824 137.475 117.593V83.4132C137.475 83.1829 137.662 82.9961 137.892 82.9961Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6294 123.739C100.138 124.743 100.855 126.047 101.691 127.506C102.489 128.9 103.396 130.436 103.165 132.197C103.156 132.269 103.145 132.341 103.133 132.413",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M176.41 99.3178C176.41 98.4799 175.731 97.8008 174.893 97.8008C174.055 97.8008 173.376 98.4799 173.376 99.3178C173.376 100.156 174.055 100.835 174.893 100.835C175.731 100.835 176.41 100.156 176.41 99.3178Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M160.876 57.19C160.876 55.1838 159.249 53.5575 157.243 53.5575C155.237 53.5575 153.611 55.1838 153.611 57.19C153.611 59.1962 155.237 60.8225 157.243 60.8225C159.249 60.8225 160.876 59.1962 160.876 57.19Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M123.069 22.6824L120.775 16.118",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M120.984 24.9745L116.291 20.0774",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M119.211 27.1626L111.598 24.662",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M142.481 44.3997C142.481 44.2184 142.334 44.0714 142.153 44.0714C141.972 44.0714 141.825 44.2184 141.825 44.3997C141.825 44.581 141.972 44.728 142.153 44.728C142.334 44.728 142.481 44.581 142.481 44.3997Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M178.729 44.0522C178.729 43.8709 178.582 43.7239 178.401 43.7239C178.22 43.7239 178.073 43.8709 178.073 44.0522C178.073 44.2335 178.22 44.3805 178.401 44.3805C178.582 44.3805 178.729 44.2336 178.729 44.0522Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M83.395 120.037L87.1361 127.438",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M92.041 136.691L95.1633 142.705",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M105.522 137.016C105.731 141.019 105.94 145.021 106.148 149.023C106.072 149.214 105.929 149.361 105.74 149.442C105.551 149.524 105.346 149.526 105.155 149.45C101.825 147.202 98.4938 144.953 95.1631 142.705C96.1366 142.878 97.1101 143.051 97.9314 142.677C98.3119 142.504 98.6596 142.213 98.8785 141.812C99.2189 141.189 99.2475 140.297 99.6392 139.969C100.163 139.529 101.337 140.097 102.307 139.992C103.123 139.904 103.795 139.34 104.092 138.558C104.225 138.205 104.283 137.808 104.484 137.718C104.762 137.595 105.313 138.057 105.481 137.831C105.575 137.704 105.549 137.36 105.522 137.016ZM105.522 137.016C104.913 135.842 104.303 134.668 103.694 133.494",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M103.694 133.494C96.9411 120.486 95.4113 117.54 93.8814 114.593M93.8814 114.593C92.92 112.608 91.0837 111.387 88.8816 111.268C86.6795 111.149 84.7221 112.165 83.5524 114.034C82.3827 115.904 82.3249 118.109 83.395 120.037C86.8081 118.265 90.2212 116.493 93.6343 114.721C93.7167 114.678 93.799 114.636 93.8814 114.593Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9517 122.375L91.7639 129.71",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2974 134.786L96.053 138.22",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0532 138.22L97.1531 140.371",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0605 120.247L101.195 136.156",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M101.195 136.156L102.262 138.243",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M219.977 140.599H289.069",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M289.069 154.133H219.977",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M226.068 140.599H223.795V154.133H226.068V140.599Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M224.623 126.77L281.273 126.774",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M224.623 128.689L280.027 128.518",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M224.623 137.954L280.027 137.782",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M224.623 139.784L281.17 139.613",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M280.056 137.782C281.345 134.827 281.335 131.465 280.027 128.518",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M281.17 139.612C283.479 135.654 283.519 130.769 281.273 126.774",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M226.812 128.683L226.84 137.947",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M285.724 147.366C285.724 145.592 284.286 144.154 282.513 144.154C280.739 144.154 279.301 145.592 279.301 147.366C279.301 149.14 280.739 150.578 282.513 150.578C284.286 150.578 285.724 149.14 285.724 147.366Z",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M224.623 128.69L224.623 126.77",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M224.623 137.954L224.628 139.784",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M219.977 140.599C216.972 144.61 216.972 150.122 219.977 154.133",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M289.069 154.133C292.074 150.122 292.074 144.61 289.069 140.599",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M121.067 82.0271C111.99 84.6168 102.913 87.2065 94.0726 90.6772C88.5975 92.8269 83.2135 95.3145 78.9435 97.0655C75.3614 98.5344 72.5633 99.4847 70.1404 101.522C68.7598 102.683 67.501 104.196 67.0339 106.282C66.1457 110.25 68.1222 116.289 69.9403 120.413C71.6771 124.352 73.2693 126.543 76.7876 128.945C76.8544 128.991 76.9219 129.037 76.9901 129.082",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7202 136.554C91.7359 136.561 91.7518 136.568 91.7675 136.575",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M121.131 92.104C120.288 92.3451 119.447 92.5859 118.61 92.827C115.722 93.6588 112.875 94.4947 110.076 95.362C107.752 96.0822 105.462 96.824 103.208 97.6021C101.416 98.2206 99.6474 98.8619 97.9032 99.5333C96.9908 99.8845 96.0836 100.245 95.1657 100.619C94.2477 100.993 93.3252 101.378 92.4046 101.768C90.5636 102.548 88.7322 103.346 86.9505 104.119C85.4528 104.768 83.991 105.398 82.5707 105.987C81.942 106.247 81.3238 106.498 80.737 106.732C80.3726 106.877 80.018 107.017 79.6724 107.152",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M105.515 96.6707C104.747 94.9662 103.979 93.2618 102.831 91.8615C101.85 90.6661 100.593 89.6923 99.335 88.7185",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4094 102.149C90.7861 100.554 90.1628 98.9589 89.1254 97.7132C88.0305 96.3984 86.4745 95.4726 84.9185 94.5469",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6721 107.153C79.0424 106.196 78.3313 105.199 76.7614 103.779C75.41 102.556 73.4221 101.021 71.8735 100.271",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5361 149.723C70.8114 149.284 72.0865 148.845 73.3869 148.553C75.9297 147.981 78.5688 147.97 81.2362 147.985C86.0975 148.013 91.0534 148.129 95.4544 149.864C97.4096 150.635 99.2554 151.726 101.101 152.816",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M133.621 150.705C132.059 150.077 130.497 149.45 128.888 149.053C126.362 148.43 123.719 148.375 121.05 148.344C116.185 148.288 111.231 148.312 106.8 149.967C104.832 150.702 102.966 151.759 101.101 152.816",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1235 152.851L69.5361 149.723",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1235 152.851C68.9576 152.191 70.7917 151.531 72.6738 151.085C75.0698 150.518 77.5437 150.299 80.0312 150.166C84.3632 149.934 88.7366 149.964 92.9238 150.882C95.3509 151.414 97.7155 152.244 100.08 153.075",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M135.067 153.381C133.239 152.947 131.41 152.512 129.573 152.13C127.154 151.627 124.72 151.216 122.254 150.941C117.959 150.463 113.567 150.401 109.344 151.183C106.896 151.637 104.504 152.374 102.112 153.112",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M135.068 153.382L133.621 150.736",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4963 152.207L69.6611 154.437",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6611 154.437C70.3779 154.044 71.0947 153.652 71.8501 153.393C73.4741 152.836 75.2765 152.897 77.0331 152.83C78.5095 152.774 79.9535 152.628 81.4059 152.552C84.6459 152.382 87.9279 152.559 91.1729 152.926C94.3416 153.285 97.4748 153.826 100.608 154.366",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M133.293 154.46C132.225 154.203 131.157 153.946 130.078 153.749C128.37 153.438 126.635 153.278 124.902 153.123C123.446 152.992 121.991 152.865 120.533 152.791C117.28 152.627 114.007 152.731 110.762 153.046C107.594 153.353 104.452 153.862 101.31 154.371",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M133.293 154.46L132.623 153.145",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1357 127.438C87.9217 127.97 88.7077 128.503 89.5228 128.898C90.9293 129.581 92.4226 129.856 94.1259 130.357C94.855 130.572 95.6224 130.828 96.0228 131.178C97.3097 132.303 94.8014 134.398 92.1993 136.517",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6721 107.152C78.8169 107.627 77.9617 108.102 77.3845 108.793C76.2084 110.2 76.1868 112.5 76.614 114.477C77.039 116.444 77.9082 118.089 78.9169 119.699C79.8956 121.26 81.0057 122.787 82.3477 124.045C82.4354 124.127 82.5241 124.208 82.6137 124.288",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7676 136.575C91.911 136.638 92.0779 136.616 92.1995 136.517",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6892 124.575C84.6641 124.48 83.6389 124.384 82.6138 124.288",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9353 136.488C91.2334 136.704 90.5316 136.921 89.8328 136.978C87.7763 137.146 85.7474 135.936 83.9149 134.664C81.3499 132.884 79.1701 130.983 76.9902 129.082",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2512 113.371C75.0542 113.474 73.8573 113.576 72.734 113.906C71.1935 114.36 69.7916 115.244 68.3896 116.127",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1863 121.576C77.8855 123.036 75.5845 124.496 73.2837 125.957",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M189.697 97.6867C195.6 94.9943 198.202 88.0262 195.51 82.1233C194.336 79.5486 192.271 77.4844 189.697 76.3101",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M201.564 80.8269C206.027 84.4391 210.49 88.0513 215.738 90.5831C221.553 93.3882 228.331 94.8674 234.637 93.1009C239.323 91.7881 243.749 88.6825 245.975 84.6037C247.52 81.7741 248.006 78.4762 248.33 75.1064",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M196.422 88.8511C196.873 89.2151 197.33 89.5829 197.793 89.9536C199.286 91.1468 200.85 92.3694 202.518 93.5776C204.242 94.8262 206.077 96.0597 208.06 97.2156C210.687 98.7473 213.59 100.141 216.707 101.209C219.825 102.276 223.167 103.033 226.687 103.265C228.695 103.397 230.76 103.357 232.853 103.094C234.187 102.927 235.532 102.669 236.873 102.309C238.695 101.821 240.469 101.157 242.165 100.335C243.862 99.5135 245.488 98.5326 247.019 97.3878C248.55 96.243 249.988 94.9335 251.286 93.4408C251.945 92.6836 252.567 91.879 253.143 91.0248C253.583 90.3724 253.998 89.6875 254.377 88.981C254.755 88.2745 255.087 87.5661 255.379 86.8638C256.083 85.1683 256.553 83.5138 256.892 81.9507C257.232 80.3875 257.442 78.9115 257.6 77.5329C257.634 77.2298 257.667 76.9314 257.697 76.6377",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M260.725 65.7383C269.427 59.6918 273.532 56.931 277.637 54.1701C281.157 42.1478 284.677 30.1255 288.197 18.1031C280.976 22.8417 273.755 27.5802 266.534 32.3188C266.395 32.7297 266.256 33.1407 266.038 33.4831C265.461 34.3864 264.329 34.8132 263.198 35.2399C261.999 35.3929 260.799 35.5458 259.866 35.0179C259.513 34.8179 259.197 34.5199 258.882 34.222C248.136 33.2174 237.39 32.2127 226.645 31.208C223.314 42.887 219.983 54.5661 216.652 66.2451C225.692 67.4657 234.731 68.6862 251.465 70.7961",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M231.928 26.8383C234.212 26.2401 236.497 25.642 238.796 25.4185C242.214 25.086 245.663 25.5823 249.217 25.8919C253.212 26.24 257.339 26.3522 260.703 28.2583C261.438 28.6745 262.136 29.1763 262.835 29.6781C262.783 28.2948 262.731 26.9115 262.835 25.5368C262.972 23.7262 263.38 21.9306 264.019 20.2125C264.964 17.6678 266.415 15.2932 268.282 13.35C268.92 12.6853 269.608 12.071 270.295 11.4568",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M238.915 28.3766C240.649 28.4137 242.383 28.4508 244.125 28.4949C246.905 28.5651 249.705 28.6529 252.414 29.2049C254.014 29.5309 255.582 30.0186 257.15 30.5064",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M267.808 25.1819C268.873 23.8569 269.937 22.5318 270.886 21.0406C272.411 18.6462 273.639 15.8234 275.861 14.4149C277.257 13.5299 279.045 13.2033 280.834 12.8766",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M273.492 23.2886C274.887 21.6516 276.282 20.0146 277.992 18.7925C279.09 18.0082 280.317 17.3947 281.545 16.7812",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M258.765 34.2111L253.451 58.6977",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M266.531 32.3296L260.552 59.7869",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M206.906 96.5248C207.551 95.2034 208.197 93.8821 208.935 92.6152C209.787 91.1535 210.762 89.7644 211.737 88.3752",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M223.012 102.83C223.04 100.912 223.068 98.993 223.304 97.0978C223.459 95.8491 223.705 94.6104 223.95 93.3718",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M240.833 100.942C239.893 99.7392 238.954 98.5371 238.561 97.2013C238.035 95.4071 238.495 93.3717 238.956 91.3364",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M252.566 91.8431C251.546 90.7867 250.525 89.7304 249.385 88.8272C248.05 87.769 246.55 86.9212 245.05 86.0735",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M248.995 74.9675C248.375 74.2346 247.755 73.5017 247.389 72.6369C247.074 71.8947 246.947 71.0554 246.994 70.2305",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M251.465 70.7961C251.6 71.138 251.814 71.3921 252.168 71.3812C252.471 71.3718 252.875 71.1684 253.189 70.9541C253.902 70.4669 254.145 69.923 254.41 69.3259C254.816 68.4134 255.272 67.3766 255.578 66.3701C256.018 64.9242 256.149 63.5411 255.748 61.6906C255.532 60.6934 255.161 59.5606 255.45 59.396C255.69 59.2596 256.383 59.7892 256.954 60.3024C257.912 61.1635 258.526 61.9784 259.051 63.0037C259.557 63.9913 259.981 65.1739 260.191 66.3701C260.449 67.8351 260.386 69.3203 260.036 70.7206C259.649 72.2631 258.914 73.7026 257.911 75.0192C257.086 76.1013 256.081 77.1005 254.852 77.5052C253.85 77.8355 252.7 77.77 251.639 77.4016C250.674 77.0669 249.784 76.4818 249.306 75.6408C249.185 75.4273 249.09 75.1974 248.995 74.9675",
    stroke: "#8B8C95",
    strokeWidth: 0.7087,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderTraining);
export default __webpack_public_path__ + "static/media/under-training.09096f15e9af26334a8a911d13e1da52.svg";
export { ForwardRef as ReactComponent };